// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --main-color: main-palette(500);
  --main-bg: #fff;
  --boxed-width: 1140px;
}

.actions {
  align-items: center;
  display: flex;
  flex-grow: 2;
  justify-content: flex-end;
  margin: 0 !important;
}
.actions .item {
  margin: 0 0.7142857143rem;
  cursor: pointer;
}
.actions .item .icon.log-out {
  margin: 0 !important;
  margin-left: auto !important;
  opacity: 0.2;
  color: #000 !important;
}
.actions .item .tc-badge {
  justify-content: center;
  font-size: 0.8em;
  min-width: 18px;
  height: 18px;
  padding-left: 2px;
  padding-right: 2px;
  position: absolute;
  right: -5px;
  text-align: center;
  top: -5px;
}
.actions .item:hover .tc-icon {
  opacity: 1;
}
.actions .item.active .tc-icon {
  color: #336cfb;
  opacity: 1;
}

.item-link {
  transition: color 0.2s ease-in-out;
}
.item-link:hover {
  color: #1f2022;
}

.notification-icon {
  opacity: 0.5;
  transition: opacity 0.25s ease-in-out, color 0.25s ease-in-out;
}
.notification-icon.active, .notification-icon:hover {
  color: #336cfb;
  opacity: 0.8;
}

.dropdown-link-wrap {
  position: relative;
}

.dropdown-title {
  font-size: 1.1em;
  margin: 0;
  padding: 0.7142857143rem 1.4285714286rem;
}

.actions-menu {
  background: #fff;
  border-radius: 6px;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  justify-content: center;
  list-style-type: none;
  margin: 0.7142857143rem 0 0;
  padding: 0.7142857143rem 0;
}

.action-badge .ant-badge-count {
  background: #ed5564;
}

.action-item > a {
  align-items: center;
  color: main-palette(500);
  color: var(--main-color);
  display: flex;
  padding: 0.7142857143rem 1.4285714286rem;
}
.action-item .icon {
  border-radius: 50%;
  background: #e8e8e8;
  color: inherit;
  font-size: 1rem;
  padding: 0.7142857143rem;
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
  width: auto;
}
.action-item .text {
  display: flex;
  flex-direction: column;
  color: inherit;
  font-size: 0.9em;
  transition: color 0.2s ease-in-out;
}
.action-item .text .sub-text {
  font-size: 0.8em;
  margin-top: 0.1785714286rem;
  line-height: 1;
  opacity: 0.6;
}
.action-item:hover .text {
  color: #336cfb;
}
.action-item:hover .icon {
  background-color: #336cfb;
  color: #ffffff;
}

.dropdown-header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 0.7142857143rem 1.4285714286rem;
}
.dropdown-header > * {
  padding: 0;
}
.dropdown-header .dropdown-title {
  font-size: 1.25rem;
  padding: 0;
}

.dropdown-actions {
  padding: 0.7142857143rem 1.4285714286rem;
  width: 100%;
}

.ant-badge-count {
  box-shadow: 0 0 0 2px var(--navbar-bg) !important;
  height: 18px;
  min-width: 18px;
}

.empty-item {
  display: block;
  padding: 0.7142857143rem 1.4285714286rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/sass/_variables.scss","webpack://./src/layout/components/actions/Actions.scss"],"names":[],"mappings":"AAmGA;EACE,+BAAA;EACA,eAAA;EACA,qBAAA;AClGF;;AAFA;EACE,mBAAA;EACA,aAAA;EACA,YAAA;EACA,yBAAA;EACA,oBAAA;AAKF;AAHE;EACE,yBAAA;EACA,eAAA;AAKJ;AAFM;EACE,oBAAA;EACA,4BAAA;EACA,YAAA;EACA,sBAAA;AAIR;AADI;EACE,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;AAGN;AAAM;EACE,UAAA;AAER;AAEM;EACE,cAAA;EACA,UAAA;AAAR;;AAMA;EACE,kCAAA;AAHF;AAKE;EACE,cAAA;AAHJ;;AAOA;EACE,YAAA;EACA,8DAAA;AAJF;AAME;EAEE,cAAA;EACA,YAAA;AALJ;;AASA;EACE,kBAAA;AANF;;AASA;EACE,gBAAA;EACA,SAAA;EACA,wCAAA;AANF;;AASA;EACE,gBAAA;EACA,kBDgDM;EC/CN,4CDkDa;ECjDb,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,2BAAA;EACA,0BAAA;AANF;;AASE;EACE,mBD0BU;AChCd;;AAUE;EACE,mBAAA;EACA,wBAAA;EAAA,wBAAA;EACA,aAAA;EACA,wCAAA;AAPJ;AAUE;EACE,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,wBDoBS;ECnBT,qEAAA;EACA,WAAA;AARJ;AAWE;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;EACA,kCAAA;AATJ;AAWI;EACE,gBAAA;EACA,2BAAA;EACA,cAAA;EACA,YAAA;AATN;AAcI;EACE,cAAA;AAZN;AAeI;EACE,yBAAA;EACA,cAAA;AAbN;;AAkBA;EACE,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,wCAAA;AAfF;AAiBE;EACE,UAAA;AAfJ;AAiBE;EACE,kBAAA;EACA,UAAA;AAfJ;;AAmBA;EACE,wCAAA;EACA,WAAA;AAhBF;;AAmBA;EACE,iDAAA;EACA,YAAA;EACA,eAAA;AAhBF;;AAmBA;EACE,cAAA;EACA,wCAAA;AAhBF","sourcesContent":["@import './mixins';\n\n//Main palette\n$palette: (\n  50: #e4e4e4,\n  100: #bcbcbd,\n  200: #8f9091,\n  300: #626364,\n  400: #414143,\n  500: #1f2022,\n  600: #1b1c1e,\n  700: #171819,\n  800: #121314,\n  900: #0a0b0c,\n  A100: #52ffff,\n  A200: #1fffff,\n  A400: #00ebeb,\n  A700: #00d2d2,\n  bloulder100 : #E7E7E7,\n  bloulder400 : #7B7B7B,\n  bloulder500 : #6D6D6D,\n  bloulder600 : #5D5D5D,\n  bloulder900 : #3D3D3D,\n  bloulder950 : #262626,\n  perano50 : #F5F8FF,\n  perano400 : #9099E9,\n  perano500 : #7578DF,\n  Lavender500: #BD80C2\n);\n\n$contrast: (\n  50: #000000,\n  100: #000000,\n  200: #000000,\n  300: #ffffff,\n  400: #ffffff,\n  500: #ffffff,\n  600: #ffffff,\n  700: #ffffff,\n  800: #ffffff,\n  900: #ffffff,\n  A100: #000000,\n  A200: #000000,\n  A400: #000000,\n  A700: #000000\n);\n\n@function main-palette($key: $palette) {\n  @return map-get($palette, $key);\n}\n@function main-contrast($key: $palette) {\n  @return map-get($contrast, $key);\n}\n\n//Accent palette\n$accent-palette: (\n  50: #e7edff,\n  100: #c2d3fe,\n  200: #99b6fd,\n  300: #7098fc,\n  400: #5282fc,\n  500: #336cfb,\n  600: #2e64fa,\n  700: #2759fa,\n  800: #204ff9,\n  900: #143df8,\n  A100: #ffffff,\n  A200: #f4f6ff,\n  A400: #c1caff,\n  A700: #a7b4ff\n);\n\n$accent-contrast: (\n  50: #000000,\n  100: #000000,\n  200: #000000,\n  300: #000000,\n  400: #000000,\n  500: #ffffff,\n  600: #ffffff,\n  700: #ffffff,\n  800: #ffffff,\n  900: #ffffff,\n  A100: #000000,\n  A200: #000000,\n  A400: #000000,\n  A700: #000000\n);\n\n$themeBtnBg : linear-gradient(90deg, #DBCDF0 15%, #F2C6DE 40%)\n;\n\n@function accent-palette($key: $accent-palette) {\n  @return map-get($accent-palette, $key);\n}\n@function accent-contrast($key: $accent-palette) {\n  @return map-get($accent-contrast, $key);\n}\n\n:root {\n  --main-color: main-palette(500);\n  --main-bg: #fff;\n  --boxed-width: 1140px;\n}\n\n$main-color: main-palette(500);\n$main-bg: #fff;\n$boxed-width: 1140px;\n\n$success-color: #b7ce63;\n$success-contrast: #000;\n$info-color: #64b5f6;\n$info-contrast: #000;\n$warning-color: #e9e165;\n$warning-contrast: #000;\n$error-color: #ed5564;\n$error-contrast: #fff;\n$paragraph-text: main-palette(300);\n\n//Main\n$main-fs: 14px;\n$main-ff: 'Lato', sans-serif;\n$main-fw: 400;\n$module: 10px;\n$main-lh: ($module * 2 / $main-fs);\n$module-rem: ($module / $main-fs) * 1rem;\n$shape: 6px;\n$shadow: 0 18px 24px rgba(#000, 0.12);\n$shadow-consulatant: 0 3px 10px rgba(#000, 0.12);\n$shadow-hover: 0px 8px 24px rgba(#000, 0.12);\n$animation: ease-in-out;\n\n//Second\n$second-ff: $main-ff;\n\n$fontNunito : 'Nunito Sans',sans-serif;\n\n//Media\n$max543: 'only screen and (max-width: 543px)';\n$min544: 'only screen and (min-width: 544px)';\n$max575: 'only screen and (max-width: 575px)';\n$max767: 'only screen and (max-width: 767px)';\n$min768: 'only screen and (min-width: 768px)';\n$max991: 'only screen and (max-width: 991px)';\n$min992: 'only screen and (min-width: 992px)';\n$max1199: 'only screen and (max-width: 1199px)';\n$max1366: 'only screen and (max-width: 1366px)';\n$max1400: 'only screen and (max-width: 1400px)';\n$max1599: 'only screen and (max-width: 1599px)';\n$min1200: 'only screen and (min-width: 1200px)';\n\n//Headers\n$headers-ff: $second-ff;\n$headers-fw: 700;\n\n//navbar\n$navbar-bg: #eeeeef;\n$navbar-color: rgba(main-palette(500), 0.5);\n$vertical-navbar-width: $module-rem * 24;\n\n//footer\n$footer-height: $module-rem * 6;\n\n//Preloader\n$loader-overlay-bg: #fff;\n$loader-color: accent-palette(500);\n\n\n$themeShadow : 0px 0px 6px 2px rgba(212, 196, 236, 0.6);\n$altBtnShadow : 0px 0px 4px 0px rgba(212, 196, 236, 0.6);\n$pinkColor : main-palette(Lavender500);\n$Lavender200 : #EEDDF1;\n$themeBlack : main-palette(bloulder950);\n$bloulder500 : main-palette(bloulder500);\n$bloulder600 : main-palette(bloulder600);\n$bloulder900 : main-palette(bloulder900);\n$perano50 : main-palette(perano50);\n$perano400 : main-palette(perano400);\n","@import '../../../assets/sass/variables';\n\n.actions {\n  align-items: center;\n  display: flex;\n  flex-grow: 2;\n  justify-content: flex-end;\n  margin: 0 !important;\n\n  .item {\n    margin: 0 $module-rem;\n    cursor: pointer;\n\n    .icon {\n      &.log-out {\n        margin: 0 !important;\n        margin-left: auto !important;\n        opacity: 0.2;\n        color: #000 !important;\n      }\n    }\n    .tc-badge {\n      justify-content: center;\n      font-size: 0.8em;\n      min-width: 18px;\n      height: 18px;\n      padding-left: 2px;\n      padding-right: 2px;\n      position: absolute;\n      right: -5px;\n      text-align: center;\n      top: -5px;\n    }\n    &:hover {\n      .tc-icon {\n        opacity: 1;\n      }\n    }\n    &.active {\n      .tc-icon {\n        color: accent-palette(500);\n        opacity: 1;\n      }\n    }\n  }\n}\n\n.item-link {\n  transition: color 0.2s $animation;\n\n  &:hover {\n    color: main-palette(500);\n  }\n}\n\n.notification-icon {\n  opacity: 0.5;\n  transition: opacity 0.25s ease-in-out, color 0.25s ease-in-out;\n  \n  &.active,\n  &:hover {\n    color: accent-palette(500);\n    opacity: 0.8;\n  }\n}\n\n.dropdown-link-wrap {\n  position: relative;\n}\n\n.dropdown-title {\n  font-size: 1.1em;\n  margin: 0;\n  padding: $module-rem ($module-rem * 2);\n}\n\n.actions-menu {\n  background: #fff;\n  border-radius: $shape;\n  box-shadow: $shadow-hover;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  list-style-type: none;\n  margin: $module-rem 0 0;\n  padding: $module-rem 0;\n}\n.action-badge {\n  .ant-badge-count {\n    background: $error-color;\n  }\n}\n.action-item {\n  > a {\n    align-items: center;\n    color: var(--main-color);\n    display: flex;\n    padding: $module-rem ($module-rem * 2);\n  }\n\n  .icon {\n    border-radius: 50%;\n    background: #e8e8e8;\n    color: inherit;\n    font-size: 1rem;\n    padding: $module-rem;\n    transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;\n    width: auto;\n  }\n\n  .text {\n    display: flex;\n    flex-direction: column;\n    color: inherit;\n    font-size: 0.9em;\n    transition: color 0.2s ease-in-out;\n\n    .sub-text {\n      font-size: 0.8em;\n      margin-top: calc($module-rem / 4);\n      line-height: 1;\n      opacity: 0.6;\n    }\n  }\n\n  &:hover {\n    .text {\n      color: accent-palette(500);\n    }\n\n    .icon {\n      background-color: accent-palette(500);\n      color: accent-contrast(500);\n    }\n  }\n}\n\n.dropdown-header {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  padding: $module-rem ($module-rem * 2);\n\n  > * {\n    padding: 0;\n  }\n  .dropdown-title {\n    font-size: 1.25rem;\n    padding: 0;\n  }\n}\n\n.dropdown-actions {\n  padding: $module-rem ($module-rem * 2);\n  width: 100%;\n}\n\n.ant-badge-count {\n  box-shadow: 0 0 0 2px var(--navbar-bg) !important;\n  height: 18px;\n  min-width: 18px;\n}\n\n.empty-item {\n  display: block;\n  padding: $module-rem ($module-rem * 2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
